module.exports = function (index, column, options) {
  var html = '';  
  
  if(index%column == 0){
    html += '<!--[if mso | IE]>' +
              '<tr>'+
            '<![endif]-->';
  }

  var paddingLeft = index%column == 0 ? 10 : 0; 

  html += '<!--[if mso | IE]>' +
            '<td style="vertical-align:top;width:290px;">'+
          '<![endif]-->';
            
  html += '<div class="mj-column-per-50 outlook-group-fix" style="vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%; padding-bottom: 5px; max-width: 290px;">'
            + options.fn(this) + '</div>';

  html += '<!--[if mso | IE]>'+
            '</td>' +
          '<![endif]-->'            

  if(index%column != 0){
    html += '<!--[if mso | IE]>'+
              '</tr>'+
            '<![endif]-->';
  }

  return html;
};